export default __webpack_public_path__ + "static/map-locator-5b7c8e1d40ed932310a74e8278562e21.png";